import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { GameForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class GameNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Game'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <GameForm 
                    path="games"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(GameNew)
